/**
 * Settings — the hub that gathers what used to be scattered across the app:
 * the search, resume, answers and tracks (each still its own screen), plus
 * email and the account controls that used to sit in the dashboard footer.
 *
 * A hub, not a rebuild: the profile items link out to the screens that already
 * own them; email and account render inline because they are small.
 */

import { AccountSection } from "./Account";
import { EmailUpdates } from "./EmailUpdates";
import { AlertsSwitch } from "./Alerts";
import { BillingSection } from "./Billing";

interface SettingsProps {
  onBack: () => void;
  onGo: (go: string) => void;
  onSignOut: () => Promise<void>;
}

const PROFILE: Array<{ go: string; label: string; hint: string }> = [
  { go: "preferences", label: "Search", hint: "Titles, places and pay floor — obeyed exactly." },
  { go: "resume", label: "Resume", hint: "The resume in use, and any others you keep." },
  { go: "answers", label: "Application answers", hint: "Work authorization and the rest — and your saved question answers." },
  { go: "tracks", label: "Job-type tracks", hint: "A separate search, resume and matches per kind of role." },
];

export default function Settings({ onBack, onGo, onSignOut }: SettingsProps) {
  return (
    <>
      <header className="bar">
        <div>
          <h1 className="tight">Settings</h1>
          <p className="muted small">Your search and profile, email, and your account — all in one place.</p>
        </div>
        <button className="btn ghost small" onClick={onBack}>Back</button>
      </header>

      <h2>Your search &amp; profile</h2>
      <ul className="set-list">
        {PROFILE.map((p) => (
          <li key={p.go}>
            <button className="set-row" onClick={() => onGo(p.go)}>
              <span className="set-body">
                <span className="set-label">{p.label}</span>
                <span className="muted small">{p.hint}</span>
              </span>
              <span className="set-arrow" aria-hidden="true">→</span>
            </button>
          </li>
        ))}
      </ul>

      <h2>Email</h2>
      <AlertsSwitch />
      <EmailUpdates />

      {/* Renders nothing until billing is switched on. */}
      <BillingSection />

      <AccountSection onDeleted={onSignOut} />

    </>
  );
}
